import { createContext, useContext } from 'react';

import type { SiteActionHandlers } from '../blocks/AiAppUI/actions/actionTypes';

export const SiteActionContext = createContext<SiteActionHandlers>({});

export const useSiteActions = () => useContext(SiteActionContext);
